export const UPDATE_SELECT_ROW_PEOPLE = 'UPDATE_SELECT_ROW_PEOPLE'
export const UPDATE_COLUMN_FILE_PEOPLE = 'UPDATE_COLUMN_FILE_PEOPLE'
export const UPDATE_LOADING_CREATE_PEOPLE = 'UPDATE_LOADING_CREATE_PEOPLE'
export const UPDATE_STEP_IMPORT_FILE = 'UPDATE_STEP_IMPORT_FILE'
export const UPDATE_SELECT_TAG_CREATE = 'UPDATE_SELECT_TAG_CREATE'
export const UPDATE_SELECT_EDIT_PEOPLE_PROFILE = 'UPDATE_SELECT_EDIT_PEOPLE_PROFILE'
export const UPDATE_MODE_PEOPLE_PROFILE = 'UPDATE_MODE_PEOPLE_PROFILE'
export const UPDATE_FILE_PEOPLE_IMPORT = 'UPDATE_FILE_PEOPLE_IMPORT'
export const UPDATE_IMPORT_DATA = 'UPDATE_IMPORT_DATA'
export const UPDATE_STATUS_FETCH = 'UPDATE_STATUS_FETCH'